import * as css from 'css/exports.module.scss';
import './AppHeader.scss';
import { BreadcrumbHeader } from './BreadcrumbHeader';
import classNames from 'classnames';
import { ImpersonatorNotice } from '@ui/ImpersonatorNotice';
import { NotificationsMenu } from './NotificationsMenu';
import React from 'react';
import { UserMenu } from './UserMenu';
import { Col, Row, Space } from 'antd';
export const AppHeader = ({ hasDropShadow }) => React.createElement("div", { className: classNames('app-header', { 'drop-shadow': hasDropShadow }) },
    React.createElement(Row, { align: 'middle', justify: 'space-between' },
        React.createElement(Col, null,
            React.createElement(BreadcrumbHeader, null)),
        React.createElement(Col, null,
            React.createElement(Space, { align: 'center', size: Number(css.size16) },
                React.createElement(ImpersonatorNotice, null),
                React.createElement(NotificationsMenu, null),
                React.createElement(UserMenu, null)))));
